import { VersionLabel, VersionState, VersionStatus } from '../utils/enums';
import { IconType } from '../components/shared/custom-icon/custom-icon';

export interface VersionStateData {
    label: VersionLabel;
    iconType: IconType;
    isCommittable: boolean;
}

class VersionStatusAndStateMap {
    private readonly statusStateMap = new Map<string, VersionStateData>();

    constructor() {
        this.set(VersionState.ACTIVE, VersionStatus.PUSH_OK,
            { label: VersionLabel.Active, iconType: IconType.STATUS_ACTIVE, isCommittable: false });
        this.set(VersionState.INACTIVE, VersionStatus.DRAFT,
            { label: VersionLabel.Draft, iconType: IconType.STATUS_DRAFT, isCommittable: true });
        this.set(VersionState.INACTIVE, VersionStatus.PUSH_SENT,
            { label: VersionLabel.Pending, iconType: IconType.STATUS_PENDING, isCommittable: false });
        this.set(VersionState.INACTIVE, VersionStatus.COMMIT_SENT,
            { label: VersionLabel.Pending, iconType: IconType.STATUS_PENDING, isCommittable: false });
        this.set(VersionState.INACTIVE, VersionStatus.COMMIT_OK,
            { label: VersionLabel.Validated, iconType: IconType.STATUS_VALIDATED, isCommittable: true });
        this.set(VersionState.INACTIVE, VersionStatus.COMMIT_ERROR,
            { label: VersionLabel.Draft, iconType: IconType.STATUS_DRAFT, isCommittable: true });
        this.set(VersionState.INACTIVE, VersionStatus.PUSH_ERROR,
            { label: VersionLabel.Draft, iconType: IconType.STATUS_DRAFT, isCommittable: true });
        this.set(VersionState.INACTIVE, VersionStatus.PUSH_OK,
            { label: VersionLabel.Inactive, iconType: IconType.STATUS_INACTIVE, isCommittable: false });
    }

    private set(versionState: VersionState, versionStatus: VersionStatus, data: VersionStateData) {
        const key = this.getKey(versionState, versionStatus);
        this.statusStateMap.set(key, data);
    }

    private getKey(versionState: VersionState, versionStatus: VersionStatus) {
        return JSON.stringify({ state: versionState, status: versionStatus });
    }

    public get(versionState: VersionState | undefined, versionStatus: VersionStatus | undefined): VersionStateData | undefined {
        if (!versionStatus || !versionState) {
            return undefined;
        }

        const key = this.getKey(versionState, versionStatus);
        return this.statusStateMap.get(key);
    }
}

export const versionStatusAndStateMap = new VersionStatusAndStateMap();
